import React, { FC, ReactNode, useCallback, useContext } from 'react';

import { registerAnalyticsEventStegFullfort } from './analytics';
import { Skademeldingstype } from './types/generated-types';

// eslint-disable-next-line
const RegisterSporsmalFullfortContext = React.createContext<(sporsmalId: string) => void>(() => {});

export const useRegisterSporsmalFullfort = (): ((sporsmalId: string) => void) =>
    useContext(RegisterSporsmalFullfortContext);

interface Props {
    skadetype: Skademeldingstype;
    children: ReactNode;
}

export const RegisterSporsmalFullfortProvider: FC<Props> = ({ skadetype, children }) => {
    const onStegFullfort = useCallback(
        (sporsmalId: string) => registerAnalyticsEventStegFullfort(skadetype, sporsmalId),
        [skadetype],
    );

    return (
        <RegisterSporsmalFullfortContext.Provider value={onStegFullfort}>
            {children}
        </RegisterSporsmalFullfortContext.Provider>
    );
};
